import { render, staticRenderFns } from "./MiniProductCard.vue?vue&type=template&id=754f4d79&"
import script from "./MiniProductCard.vue?vue&type=script&lang=js&"
export * from "./MiniProductCard.vue?vue&type=script&lang=js&"
import style0 from "./MiniProductCard.vue?vue&type=style&index=0&id=754f4d79&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports